import ApiHelper from "../../helpers/ApiHelper";
import BaseService from "../BaseService";

class DashboardService extends BaseService {

    static url = "dashboard";
    static apis = {
        getDashboardData: { path: this.url, method: "get" },
      }

    constructor(repo) {
        super(repo);
        this.repo = new ApiHelper("dashboard");
    }

    getDashboardData(id) {
        var that = this;
        return new Promise((resolve, reject) => {
            that.axios({
                    url: DashboardService.apis.getDashboardData.path,
                    method: DashboardService.apis.getDashboardData.method,
                    authorization: true,
                })
                .then(resp => {
                    resolve(resp);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

}

export default DashboardService;